import React, { useState } from 'react';
import type { Meld } from '@shared/types';
import { TileComponent } from '../tiles/TileComponent';

interface MeldGroupProps {
  meld: Meld;
  canAdd?: boolean;
  draggingTileId?: string | null;
  onDropToMeld: (meldId: string, tileId: string, position: 'start' | 'end') => void;
}

export const MeldGroup = React.memo(function MeldGroup({
  meld,
  canAdd,
  draggingTileId,
  onDropToMeld,
}: MeldGroupProps) {
  const [hoverZone, setHoverZone] = useState<'start' | 'end' | null>(null);
  const isDragTarget = Boolean(draggingTileId) && canAdd;

  const handleDropZonePointerUp = (position: 'start' | 'end') => {
    if (draggingTileId && canAdd) {
      onDropToMeld(meld.id, draggingTileId ?? '', position);
    }
    setHoverZone(null);
  };

  return (
    <div
      className={`meld-group${isDragTarget ? ' drag-over-meld' : ''}`}
      data-meld-id={meld.id}
    >
      {/* Drop zone at start */}
      <div
        className={`meld-drop-start${isDragTarget && hoverZone === 'start' ? ' active' : ''}`}
        data-drop-zone="meld"
        data-drop-data={`${meld.id}:start`}
        onPointerEnter={() => isDragTarget && setHoverZone('start')}
        onPointerLeave={() => setHoverZone(null)}
        onPointerUp={() => handleDropZonePointerUp('start')}
      />

      {meld.tiles.map((tile) => (
        <TileComponent
          key={tile.id}
          tile={tile}
          onClick={undefined}
          disabled={true}
        />
      ))}

      {/* Drop zone at end */}
      <div
        className={`meld-drop-end${isDragTarget && hoverZone === 'end' ? ' active' : ''}`}
        data-drop-zone="meld"
        data-drop-data={`${meld.id}:end`}
        onPointerEnter={() => isDragTarget && setHoverZone('end')}
        onPointerLeave={() => setHoverZone(null)}
        onPointerUp={() => handleDropZonePointerUp('end')}
      />
    </div>
  );
});

export default MeldGroup;
